// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"f1fd09fa","498":"5958f82e","703":"1edf4800","787":"a1e5ff07"}[chunkId] + ".chunk.js";
};